import { render } from "./banner.vue?vue&type=template&id=01ce91d4"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=01ce91d4&lang=scss"
import "./banner.vue?vue&type=style&index=1&id=01ce91d4&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-sold-detail/fashion/banner.vue'],['render',render],['__file',"banner.vue"]])

export default __exports__